export default "__VITE_ASSET__BHXBwzRD__"